import { render, staticRenderFns } from "./macHuizong.vue?vue&type=template&id=40e77858&scoped=true"
import script from "./macHuizong.vue?vue&type=script&lang=js"
export * from "./macHuizong.vue?vue&type=script&lang=js"
import style0 from "./macHuizong.vue?vue&type=style&index=0&id=40e77858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e77858",
  null
  
)

export default component.exports